module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-light-300.woff2?68c2f74f76d4236722607d6eeb8b105d";